module.exports = __webpack_public_path__ + "img/product_type2.32dbd4dd.png";